import Grid from '@mui/material/Grid'
import { ITopSearchResultProps, ResultComponentSelector } from './ResultsV2/ResultComponentSelectorV2'

interface IProps extends React.HTMLAttributes<HTMLLIElement> {
  option: ITopSearchResultProps
}
export function TopSearchResultItem(props: IProps) {
  return (
    <li {...props} key={props.id}>
      <Grid container>
        <ResultComponentSelector {...props.option} />
      </Grid>
    </li>
  )
}
